/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { InsightObjectDetailsResponse } from '@jira/servicedesk__insight-common-types-object-types/src/TypesOpsgenieTeam.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import getData from './getData.tsx';

const RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
export const insightObjectResource: RouteResource<InsightObjectDetailsResponse | null> =
	createResource<InsightObjectDetailsResponse | null>({
		type: RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
		getKey: ({ match }) => match.params.objectId || '',
		getData,
		isBrowserOnly: true,
	});
